/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FolderSearchStatus {
    NotSearched = 0,
    Partial = 1,
    Full = 2,
    SomeFilesSelected = 3
}

export function FolderSearchStatusFromJSON(json: any): FolderSearchStatus {
    return FolderSearchStatusFromJSONTyped(json, false);
}

export function FolderSearchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FolderSearchStatus {
    return json as FolderSearchStatus;
}

export function FolderSearchStatusToJSON(value?: FolderSearchStatus | null): any {
    return value as any;
}

